// PreviousPathContext.tsx
import { createContext, useContext } from 'react';

export const PreviousPathContext = createContext<string | null>(null);

export const usePreviousPath = () => useContext(PreviousPathContext);
